
import { useEffect, useState } from "react";
import config from "./config";

export default function ImageSlider({ poi }) {

  const [index, setIndex] = useState(0);
  const images = poi.images;
  const imageCount = images.length;

  
    useEffect(() => {
      const interval = setInterval(() => { 
        if (imageCount >0)  
          setIndex(prev => (prev + 1) % imageCount);
      }, 3000);
      return () => clearInterval(interval);
    }, [imageCount]);

    const prevImage = () => {
      setIndex(prev => (prev - 1 + imageCount) % imageCount);
    };
  
  const nextImage = () => {
    setIndex(prev => (prev + 1) % imageCount);
  };

  {/*
    src={require(`./assets/${poi.nome}/${images[index]}`)}
    {imageCount >1 && <button className="slider-button left" onClick={prevImage}>‹</button>}
      {imageCount>1 && <button className="slider-button right" onClick={nextImage}>›</button>}
    
    */}
  
  return ( imageCount >0 &&
    <div className="slider-container">
      <div className="slider fade-slider">
            <img src={config.apiUrl+"/getimg"+"/"+poi.id_luogo+"/"+images[index]}

          alt={`${poi.nome} ${index + 1}`}
        />
      </div>
    </div>

  );
}
